export default defineNuxtRouteMiddleware((to) => {
    if (!to.path.startsWith('//') && to.path !== '/' && !to.path.endsWith('/')) {
        const { path, query, hash } = to;
        return navigateTo({ path: path + '/', query, hash }, { redirectCode: 301});
    }
})
